module.exports = __webpack_public_path__ + "img/by-region.766c7e55.svg";